"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.camelCase = void 0;
var CharType;
(function (CharType) {
    CharType[CharType["NUMBER"] = 0] = "NUMBER";
    CharType[CharType["LOWERCASE_CHARACTER"] = 1] = "LOWERCASE_CHARACTER";
    CharType[CharType["UPPERCASE_CHARACTER"] = 2] = "UPPERCASE_CHARACTER";
    CharType[CharType["WHITESPACE"] = 3] = "WHITESPACE";
    CharType[CharType["OTHER"] = 4] = "OTHER";
})(CharType || (CharType = {}));
function classifyChar(ch) {
    if (ch >= "a" && ch <= "z") {
        return CharType.LOWERCASE_CHARACTER;
    }
    if (ch >= "A" && ch <= "Z") {
        return CharType.UPPERCASE_CHARACTER;
    }
    if (ch >= "0" && ch <= "9") {
        return CharType.NUMBER;
    }
    if (["-", "_", "\t", ".", "\n", "\r", " "].indexOf(ch) >= 0) {
        return CharType.WHITESPACE;
    }
    return CharType.OTHER;
}
function genericSplit(str) {
    var charTypes = [];
    for (var i = 0; i < str.length; i++) {
        charTypes.push(classifyChar(str.charAt(i)));
    }
    function resultPlusNew(result, start, end) {
        if (end > start) {
            result.ranges.push([start, end]);
            result.length = result.length + (end - start);
        }
    }
    function loop(result, start, current) {
        var next = current + 1;
        if (current >= str.length) {
            resultPlusNew(result, start, current);
            return;
        }
        else if (charTypes[current] === CharType.WHITESPACE) {
            resultPlusNew(result, start, current);
            return loop(result, next, next);
        }
        else {
            var currCharType = charTypes[current];
            var nextCharType = charTypes[current + 1];
            var skipLevelCharType = charTypes[current + 2];
            if (currCharType === CharType.UPPERCASE_CHARACTER &&
                nextCharType === CharType.UPPERCASE_CHARACTER &&
                skipLevelCharType === CharType.LOWERCASE_CHARACTER) {
                resultPlusNew(result, start, next);
                return loop(result, next, next);
            }
            else if (nextCharType === CharType.UPPERCASE_CHARACTER &&
                currCharType !== CharType.UPPERCASE_CHARACTER) {
                resultPlusNew(result, start, next);
                return loop(result, next, next);
            }
            else if (nextCharType === CharType.NUMBER &&
                currCharType !== CharType.NUMBER) {
                resultPlusNew(result, start, next);
                return loop(result, next, next);
            }
            else {
                return loop(result, start, next);
            }
        }
    }
    var res = {
        ranges: [],
        length: 0,
    };
    loop(res, 0, 0);
    return res;
}
function genericToCase(str, firstCharMutateFn, restMutateFn, joinStr) {
    if (joinStr === void 0) { joinStr = ""; }
    var result = genericSplit(str);
    var length = result.length;
    if (length === 0) {
        return "";
    }
    var ranges = result.ranges;
    var nParts = ranges.length;
    switch (joinStr) {
        case undefined:
        case null:
            break;
        default:
            length = length + nParts - 1;
    }
    var finalParts = [];
    ranges.reduce(function (pos, _a) {
        var start = _a[0], end = _a[1];
        var i = pos;
        if (joinStr && i > 0) {
            finalParts[i] = joinStr;
            pos = pos + 1;
        }
        i = pos;
        var char = str.charAt(start);
        char = firstCharMutateFn(i, char);
        finalParts[i] = char;
        pos = pos + 1;
        for (i = start + 1; i < end; i = i + 1) {
            finalParts.push(restMutateFn(str.charAt(i)));
            pos = pos + 1;
        }
        return pos;
    }, 0);
    return finalParts.join(joinStr);
}
function camelCase(str) {
    return genericToCase(str, function (idx, char) { return (idx === 0 ? char.toLowerCase() : char.toUpperCase()); }, function (char) { return char.toLowerCase(); });
}
exports.camelCase = camelCase;
